function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Locations") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M187.545,308.865c-16.077-17.124-27.886-35.831-35.1-55.6a150.7,150.7,0,0,1-9.125-62.029A160.618,160.618,0,0,1,189.689,88.518a151.8,151.8,0,0,1,19.984-16.879,149.3,149.3,0,0,0-59.984,36.879A160.618,160.618,0,0,0,103.32,211.234a150.7,150.7,0,0,0,9.125,62.029c7.214,19.771,19.023,38.478,35.1,55.6L256,444.386l29.389-31.3Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,327.7c63.92,0,115.922-53.315,115.922-118.848S319.92,90,256,90,140.078,143.314,140.078,208.847,192.081,327.7,256,327.7ZM256,104c56.2,0,101.922,47.034,101.922,104.847S312.2,313.7,256,313.7,154.078,266.66,154.078,208.847,199.8,104,256,104Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.244,244.27a7,7,0,0,0,9.785.112l63.806-60.945a7,7,0,0,0-9.67-10.125l-58.859,56.221L210.95,198.177a7,7,0,0,0-9.9,9.9Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.338,338.447,250.9,459.4a7,7,0,0,0,10.208,0L374.662,338.447c17.38-18.512,30.18-38.829,38.045-60.385a164.619,164.619,0,0,0,9.941-67.762A174.612,174.612,0,0,0,372.229,98.636a164.119,164.119,0,0,0-232.458,0A174.618,174.618,0,0,0,89.352,210.3a164.614,164.614,0,0,0,9.941,67.762C107.159,299.62,119.959,319.937,137.338,338.447ZM103.32,211.234a160.618,160.618,0,0,1,46.369-102.716,150.118,150.118,0,0,1,212.623,0A160.617,160.617,0,0,1,408.68,211.234a150.723,150.723,0,0,1-9.125,62.029c-7.213,19.769-19.022,38.476-35.1,55.6L256,444.386,147.545,328.865c-16.077-17.124-27.886-35.831-35.1-55.6A150.7,150.7,0,0,1,103.32,211.234Z",
    style: {
      fill: "#2f55d4"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.45c1b016cb1781848edc6bb1b9b048d4.svg";
export { ForwardRef as ReactComponent };